import router from '../../router/index';
import VueJwtDecode from 'vue-jwt-decode';
const AUTH_USER_KEY = "AUTH_USER";
const AUTH_TOKEN_KEY = "AUTH_TOKEN";

export const setUser = function(user){
    localStorage.setItem(AUTH_USER_KEY,user);
}

export const getUser = function(){
    const user = localStorage.getItem(AUTH_USER_KEY);
    return user;
}

export const setToken = function(token){
    localStorage.setItem(AUTH_TOKEN_KEY,token);
}

export const getToken = function(){
    return localStorage.getItem(AUTH_TOKEN_KEY);
}

export const logout = function(){
    localStorage.removeItem(AUTH_USER_KEY);
    localStorage.removeItem(AUTH_TOKEN_KEY);
    router.push('/login')
}

export const isAuthenticated = function(){
    const token = getToken();
    if(token){
        const decoded = VueJwtDecode.decode(token);
        const User = getUser();
        if(new Date() >= new Date(decoded.exp * 1000)){
            return false;
        }
        if (User && decoded.identity == User){
            return true;
        }else{
            logout();
            return false;
        }
    }
    return false;
    
}